import { apiClient } from '../utils/apiClient';

export async function getCloudMockStatus(workspaceId) {
  const response = await apiClient.get(`/workspaces/${workspaceId}/cloud-mock`);
  return response.data;
}

export async function enableCloudMock(workspaceId) {
  try {
    const response = await apiClient.post(`/workspaces/${workspaceId}/cloud-mock`);
    return response.data;
  } catch (error) {
    const err = new Error(
      error.response?.data?.error || 'Failed to enable Cloud Mock'
    );
    if (error.response?.data?.upgrade_required) err.upgradeRequired = true;
    throw err;
  }
}

export async function disableCloudMock(workspaceId) {
  const response = await apiClient.delete(`/workspaces/${workspaceId}/cloud-mock`);
  return response.data;
}
